import React, { useEffect, useRef, useState } from 'react'
import cssStrokeWindow from './StrokeWindow.module.scss'
import {GlobalLibs, PackageVariablesLibs} from 'bc-react-package'
// #region Constant
const COMP_NAME = "StrokeWindow"
const DISPLAY_WIDTH = 320
// #endregion Constant

// #region Enumeration
const StrokeModeEnum = {
    "Play": 1,
    "Practice": 2
}
// #endregion Enumeration

// #region Member Variables
let mstrStrokeID = ""
let mblnInitialized = false
// #endregion Member Variables

function StrokeWindow(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [strokeMode, setStrokeMode] = useState(StrokeModeEnum.Play)
    // #endregion Init State

    // #region Init Ref
    let mrefIframeStroke = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)

    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        mstrStrokeID = GlobalLibs.GenerateUUID()
        mblnInitialized = true
    }
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        return () => {
            console.log(COMP_NAME + ".cleanup")
            mblnInitialized = false
        }
    }, [])
    // #endregion useEffect

    // #region Painted Me
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")
        OpenLoadingMask()
    }
    // #endregion Painted Me

    // #region OnTapHandler
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objCallbackData = {
            "Action": "StrokeWindowClose"
        }

        props.CallbackRef(objCallbackData)
    }

    function StrokePraciceOnTapHandler()
    {
        console.log(COMP_NAME + ".StrokePraciceOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        CallBCStrokeChangePlayMode(StrokeModeEnum.Practice) // Change to Practice
        setStrokeMode(StrokeModeEnum.Practice)
    }

    function StrokePlayOnTapHandler()
    {
        console.log(COMP_NAME + ".StrokePlayOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        CallBCStrokeChangePlayMode(StrokeModeEnum.Play) // Change to Play
        setStrokeMode(StrokeModeEnum.Play)
    }
    // #endregion OnTapHandler

    // #region Other Event Handler
    // #endregion Other Event Handler

    // #region LoadingMask and Alert
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }

        props.CallbackRef(objCallbackData)
    }

    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    }

    // function ShowAlert(AlertObject)
    // {
    //     console.log(COMP_NAME + ".ShowAlert")

    //     let objCallbackData = {
    //         "Action": "ShowAlertWindow",
    //         "AlertObject": AlertObject
    //     }
    //     props.CallbackRef(objCallbackData)
    // }
    // #endregion LoadingMask and Alert

    // #region Other Functions
    function CallBCStrokeChangePlayMode(FunctionMode)
    {
        console.log(COMP_NAME + ".CallBCStrokeChangePlayMode: ", FunctionMode)

        let objMessage = {
            "Credential": window.gSession.Acc.Credential,
            "Func": "ChangePlayMode",
            "Args": {
                "FuctionMode": FunctionMode
            }
        }
        let strMessage = JSON.stringify(objMessage)

        console.log(COMP_NAME + ".CallBCStrokeChangePlayMode strMessage: ", strMessage)
        mrefIframeStroke.current.contentWindow.postMessage(strMessage, PackageVariablesLibs.SysConfig.AppWebDomain)
    }

    function CallBCStrokeAreYouReady()
    {
        console.log(COMP_NAME + ".CallBCStrokeAreYouReady: ")

        let strQuestionWord = props.Arguments
        // let strQuestionWord = ''
        // if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        // {
        //     strQuestionWord = props.LUInfo.Action[mintStateActionIndex].MajorCharacter
        // }
        // else
        // {
        //     strQuestionWord = props.LUInfo.Action[mintStateActionIndex].MinorCharacter
        // }

        let objMessage = {
            "Credential": window.gSession.Acc.Credential,
            "Func": "AreYouReady",
            "Args":
            {
                // "LUType": 8, //props.LUInfo.LUType,
                "Lang": window.gSession.Acc.Preferences.Lang,
                "WordID": encodeURIComponent(strQuestionWord).replace(/%/g, "")
            }
        }
        let strMessage = JSON.stringify(objMessage)

        console.log(COMP_NAME + ".CallBCStrokeAreYouReady strMessage: ", strMessage)
        mrefIframeStroke.current.contentWindow.postMessage(strMessage, PackageVariablesLibs.SysConfig.AppWebDomain)
    }

    function GetIframeUrl()
    {
        console.log(COMP_NAME + ".GetIframeUrl")
        let strIframeUrl = ""

        let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)
        let strInApp4QueryString = window.Globals.GetQueryString4InApp()
        let strSupportLang = "en-US";
        let strTargetLang = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? "zh-CN" : "zh-TW" // 這個參數要注意 zh-CN: 簡體中文, zh-TW:繁體中文
        let strQueryString = "Credential=" + window.gSession.Acc.Credential;
        let strTargetDomain = window.location.protocol + "//" + window.location.hostname;

        if (
            (typeof (window.location.port) !== 'undefined') &&
            (window.location.port !== null) &&
            (window.location.port !== "")
        )
        {
            strTargetDomain += ":" + window.location.port
        }

        console.log("strTargetDomain: ", strTargetDomain)
        strTargetDomain = encodeURIComponent(strTargetDomain)
        strQueryString = strQueryString + "&TargetDomain=" + strTargetDomain;
        strQueryString = strQueryString + "&Env=" + intEnv;
        strQueryString = strQueryString + strInApp4QueryString;
        strQueryString = strQueryString + "&SysType=" + window.gSession.App.SysType.toString()
        strQueryString = strQueryString + "&SupportLang=" + strSupportLang;
        strQueryString = strQueryString + "&TargetLang=" + strTargetLang;
        strQueryString = strQueryString + "&DisplayWidth=" + DISPLAY_WIDTH;
        strQueryString = strQueryString + "&StrokeID=" + mstrStrokeID;
        strQueryString = strQueryString + "&PlayMode=true"
        

        strIframeUrl = PackageVariablesLibs.SysConfig.AppWebDomain + "/BCStroke/?" + strQueryString;

        return strIframeUrl
    }

    function IframeOnLoaded()
    {
        console.log(COMP_NAME + ".IframeOnLoaded")
        CloseLoadingMask()
        CallBCStrokeAreYouReady()
    }
    // #endregion Other Functions

    // #region Web Service After Process
    // #endregion Web Service After Process

    // #region Web Service
    // #endregion Web Service

    // #region Component
    function ComponentStrokePraciceButton()
    {
        console.log(COMP_NAME + ".ComponentStrokePraciceButton: ")
        return (
            <div className={cssStrokeWindow.btnStrokePracice} onClick={() => StrokePraciceOnTapHandler()}></div>
        )
    }

    function ComponentStrokePlayButton()
    {
        console.log(COMP_NAME + ".ComponentStrokePlayButton: ")
        return (
            <div className={cssStrokeWindow.btnStrokePlay} onClick={() => StrokePlayOnTapHandler()}></div>
        )
    }

    function ComponentCloseButton()
    {
        console.log(COMP_NAME + ".ComponentCloseButton: ")

        return (
            <div className={cssStrokeWindow.btnClose} onClick={() => CloseOnTapHandler()}></div>
        )
    }
    // #endregion Component

    // #region Render 
    function RenderStrokeArea()
    {
        console.log(COMP_NAME + ".RenderContentArea: ")

        let strIframeUrl = GetIframeUrl()

        // className={cssFoundationCharacters.iframeStroke}        
        return (
            <div className={cssStrokeWindow.divStrokeArea}>
                <iframe ref={mrefIframeStroke} title="IframeStroke"
                    className={cssStrokeWindow.iframeStroke}
                    onLoad={IframeOnLoaded}
                    src={strIframeUrl} scrolling="no"/>
            </div>
        )
    }

    function RenderControlToolArea()
    {
        console.log(COMP_NAME + ".RenderControlToolArea: ")

        let objBlock = null
        if(strokeMode === StrokeModeEnum.Play)
        {
            objBlock = <ComponentStrokePraciceButton />
        }
        else if(strokeMode === StrokeModeEnum.Practice)
        {
            objBlock = <ComponentStrokePlayButton />
        }

        return (
            <>
                {objBlock}
            </>
        )
    }

    function RenderContentArea()
    {
        console.log(COMP_NAME + ".RenderContentArea: ")

        return (
            <div className={cssStrokeWindow.divContentArea}>
                {RenderStrokeArea()}
                {RenderControlToolArea()}
                <ComponentCloseButton />
            </div>
        )
    }

    function RenderMain()
    {
        console.log(COMP_NAME + ".RenderMain: ")

        return (
            <div className={cssStrokeWindow.divMaskArea}>
                {RenderContentArea()}
            </div>
        )
    }

    return (
        <>
            {RenderMain()}
        </>
    )
    // #endregion Render
}

export default StrokeWindow
